// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"1372d895","725":"fb73e661","896":"8deaaa69"}[chunkId] + ".chunk.css";
};